export default __webpack_public_path__ + "static/media/trending_up.fad71cfd.svg";